import Modal from "Common/Components/Modal";
import { Pencil } from "lucide-react";
import React from "react";
import { SwatchesPicker } from "react-color";
import { Link } from "react-router-dom";
import { ProductColorType } from "types/ProductColorType";

interface ProductColorProps {
    productColors: ProductColorType[];
    onStatusChange: (color: ProductColorType) => void;
    onColorSaved: () => void;
    productVariants?: any[]; // Optional: to check if colors are assigned to variants
    // onHide: () => void;
}

export const ColorPallet: React.FC<ProductColorProps> = ({ productColors, onStatusChange, onColorSaved, productVariants = [] }) => {
    return (
        <React.Fragment>
            <Modal.Header className="bg-custom-200 dark:bg-custome-700 flex items-center justify-between p-4 border-b dark:border-zink-300/20"
                closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500">
                <Modal.Title className="text-16">{"Color Pallet"}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
                <div className="grid grid-cols-8 gap-2" style={{ height: 500 }}>
                    {productColors?.map((item: ProductColorType, index: number) => {
                        // Check if this color is assigned to any variant
                        const isAssignedToVariant = productVariants.some((variant: any) =>
                            variant.colorCode?.toLowerCase() === item.colorCode?.toLowerCase()
                        );

                        return (
                            <div key={"colorPallet_" + index} className="flex flex-col items-center justify-center rounded-lg border border-slate-200 dark:border-zink-500 "
                                style={{ width: 100, height: 60, marginLeft: 20, marginTop: 0, position: 'relative' }}>
                                <div
                                    className={`flex items-center justify-center size-6 border rounded-full ${isAssignedToVariant && item.selected
                                        ? 'border-red-500 dark:border-red-400'
                                        : 'border-slate-200 dark:border-zink-500'
                                        }`}
                                    style={{
                                        background: item.colorCode,
                                        width: 35,
                                        cursor: isAssignedToVariant && item.selected ? 'not-allowed' : 'pointer',
                                        height: 35,
                                        borderRadius: 5,
                                        textAlign: 'center',
                                        marginRight: 5,
                                        verticalAlign: 'center',
                                        color: (item.selected ? '#eaeaea' : item.colorCode),
                                        opacity: isAssignedToVariant && item.selected ? 0.8 : 1,
                                        position: 'relative'
                                    }}
                                    onClick={() => onStatusChange(item)}
                                    key={"div_color_" + index}
                                    title={isAssignedToVariant && item.selected ? `${item.colorName} (Assigned to variant - cannot deselect)` : item.colorName}
                                >
                                    {item.selected && (
                                        <div className="checkmark-single" style={{
                                            color: '#ffffff',
                                            fontSize: '10px',
                                            fontWeight: 'bold',
                                            border: '1px solid #ffffff',
                                            borderRadius: '50%',
                                            backgroundColor: 'rgba(0,0,0,0.4)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '16px',
                                            height: '16px',
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)'
                                        }}>
                                            &#10004;
                                        </div>
                                    )}
                                </div>
                                <div className="text-center">{item.colorName}</div>
                                {isAssignedToVariant && item.selected && (
                                    <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full border border-white dark:border-zink-700 flex items-center justify-center">
                                        <span className="text-white text-xs">!</span>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
                {/* <div className="flex justify-end gap-2 mt-4">
                        <button type="button" onClick={onColorSaved} className="flex items-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                            Save
                    </button>
                </div> */}

            </Modal.Body>
            <Modal.Footer>
                <div className="flex justify-end gap-0 mt-5 ">
                    <button type="button" onClick={onColorSaved} className="mr-3     flex items-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                        Save
                    </button>
                </div>
            </Modal.Footer>
        </React.Fragment>
    )
}

